<template>
  <div class="messageCollect questionWrap">
    <div
      v-for="(item, index) in currentAnswerConfig"
      :key="index"
      class="collect-wrap"
    >
      <div class="email-box collectRow" v-if="item.collectType === 'email'">
        <div class="email-icon"></div>
        <input
          type="email"
          class="row-input email-input"
          v-model="collectInfo.email"
          :placeholder="$t('enterEmail')"
        />
      </div>
      <div class="telephone-box collectRow" v-if="item.collectType === 'phone'">
        <div class="code-box">
          <div class="code-icon"></div>
          <select class="code-select" v-model="collectInfo.phoneArea">
            <option
              :value="phoneCode"
              v-for="(phoneCode, codeIndex) in codeArr"
              :key="codeIndex"
            >
              +{{ phoneCode }}
            </option>
          </select>
        </div>
        <input
          type="tel"
          inputmode="decimal"
          class="row-input phone-input"
          v-model="collectInfo.phone"
          :placeholder="$t('enterPhone')"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import answerHook from "@/hooks/answerHook";
import { watch, computed } from "vue";
import { useStore } from "vuex";
const store = useStore();

const { collectInfo, currentAnswerConfig, phoneCodeObject } = answerHook();
let phoneObjectConfig = computed(() =>
  currentAnswerConfig.value.find((item) => item.collectType === "phone")
);
let parsePhoneCodeObjectConfig = computed(() =>
  phoneObjectConfig.value
    ? phoneObjectConfig.value?.ext?.phoneCodeArr?.map((item) =>
        JSON.parse(item)
      )
    : []
);
let codeArr = [];
watch(
  () => store.state.survey.currentIndex,
  () => {
    codeArr = parsePhoneCodeObjectConfig.value.map((item, index) => {
      index === 0 &&
        collectInfo.value.phoneArea?.length === 0 &&
        (collectInfo.value.phoneArea = item.code);
      return item.code;
    });
  },
  { immediate: true }
);
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.messageCollect {
  .collect-wrap {
    width: 100%;
    margin: 10px 0;
    @media (orientation: landscape) {
      margin: 10px 0;
    }
  }
}
</style>
